import { Entity } from './entity.js';

export class SubjectEntity extends Entity
{

}